module.exports = __webpack_public_path__ + "img/nav-down.41909610.svg";